import { DCEvent, debounceEvents, UpdateStoreEvent } from "@/events/eventsDomain";
import { SuggestedCompany } from "@/types/CompanyInfo";
import { isBlank } from "@/utils/strings";
import { searchApiClient } from "./searchApiClient";

export const COMPANY_SEARCH_DEBOUNCE_MS = 300;
const COMPANY_SEARCH_TIMEOUT_ID = "company-search";

export type CompanySearchState = {
  suggestedCompanies: SuggestedCompany[];
};

export const searchCompanies = (query: string): DCEvent[] => {
  if (isBlank(query)) {
    return [
      { type: "clear-timeout", timeoutId: COMPANY_SEARCH_TIMEOUT_ID },
      clearSuggestedCompanies(),
    ];
  }
  return [
    debounceEvents(COMPANY_SEARCH_TIMEOUT_ID, COMPANY_SEARCH_DEBOUNCE_MS, [
      searchApiClient.companySearch(query, {
        onSuccess: (res) => [updateCompanySearch({ suggestedCompanies: res.data })],
        onFailure: () => [clearSuggestedCompanies()],
      }),
    ]),
  ];
};

export const clearSuggestedCompanies = (): UpdateStoreEvent =>
  updateCompanySearch({ suggestedCompanies: [] });

const updateCompanySearch = (companySearch: CompanySearchState): UpdateStoreEvent => ({
  type: "update-store",
  data: { companySearch },
});
